import { type ResourcesConfig } from 'aws-amplify';

import { config } from './index';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId,
      userPoolClientId: config.cognito.clientId,
      ...(config.cognito.endpoint ? { userPoolEndpoint: config.cognito.endpoint } : {}),
    },
  },
};
